import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useFeriadosClienteOutletContext } from 'pages/FeriadosCliente'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { feriadosCliente } from 'service/api'
import { toast } from 'sonner'

const ExcluirFeriadoModal: React.FC = () => {
    const { data } = useFeriadosClienteOutletContext()
    const { feriadoId } = useParams()
    const navigate = useNavigate()

    const { mutate } = feriadosCliente.mutations.useDelete({
        invalidateQuery: true,
    })

    const toggle = () => navigate(-1)

    const handleSubmit = () => {
        mutate(+feriadoId!, {
            onSuccess: () => {
                toast.success('Feriados excluido com sucesso!')
                toggle()
            },
            onError: () => {
                toast.error('Erro ao excluir o feriado!')
            },
        })
    }

    return (
        <Dialog.Root
            open={hasPermission(['delete', 'Feriados'])}
            onSubmit={handleSubmit}
            width="xs"
            height="auto"
        >
            <Dialog.Content>
                Deseja realmente excluir o feriado{' '}
                {data?.find(feriado => feriado.id === +feriadoId!)?.nome}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}

export default ExcluirFeriadoModal
